import styled from 'styled-components';
import 'boxicons/css/boxicons.min.css';

export const InputContainer = styled.div`
  padding: 10px 5px;
`;

export const Icon = styled.i<{ iconcolor: string }>`
  color: ${(props) => props.iconcolor};
  font-size: 20px;
`;

export const listSelectBtnStyle = {
  color: '#777',
  margin: '1% 0 0 1%',
};

export const listRemoveBtnStyle = {
  color: '#777',
  margin: '1% 1% 0 1%',
};

export const alignCenterXY = {
  display: 'flex',
  alignItems: 'center',
  height: 'fit-content',
  justifyContent: 'center',
};
